import { PlusOutlined } from '@ant-design/icons';
import { Form, Upload, message, Typography } from 'antd';
import React, { useState } from 'react';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const FormItemUploadPhoto = (props: { maxPhotos: number, includeVideo?: boolean, onChange?: (fileList: any) => void }) => {

	const includeVideo = props.includeVideo ?? false;

    const { token, projectGroup } = useAuth();
    const [uploadFileList, setUploadFileList] = useState<any[]>([]);
    const { t } = useTranslation();

    const onUploadChange = (info: any) => {
        const MIN_MEDIA_IN_BYTES = 10 * 1024; // 10 Kb
        const MAX_IMAGE_IN_BYTES = 5 * 1024 * 1024; // 5Mb
        const MAX_VIDEO_IN_BYTES = 25 * 1024 * 1024; // 25 Mb

        if (info?.fileList.length > 0) {
            const lastFile = info.fileList[info.fileList.length - 1];
            // Verificamos si es imagen por el type MIME o extensión
            const isImage = lastFile.type?.startsWith('image/') || /\.(jpg|jpeg|png)$/i.test(lastFile.name);

            if (isImage) {
                if (lastFile.size >= MAX_IMAGE_IN_BYTES || lastFile.size <= MIN_MEDIA_IN_BYTES) {
                    message.error(t('view.forms.fields.photo.errors.size'), 3);
                    return;
                }
            } else if (includeVideo) {
                if (lastFile.size >= MAX_VIDEO_IN_BYTES || lastFile.size <= MIN_MEDIA_IN_BYTES) {
                    message.error(t('view.forms.fields.photo.errors.size'), 3);
                    return;
                }
            }
        }

        let fileList = [...info.fileList];
        fileList = fileList.slice(-1 * props.maxPhotos);
        fileList = fileList.map(file => {
            if (file.response) {
                file.url = file.response.url;
            }
            return file;
        });
        setUploadFileList(fileList);
		if (props.onChange) {
            props.onChange(fileList);
        }
    };

    // Definimos qué formatos aceptar dinámicamente
    const acceptedFormats = includeVideo 
        ? 'image/jpeg,image/png,image/jpg,video/mp4,video/quicktime' 
        : 'image/jpeg,image/png,image/jpg';

    const uploadProps = {
        action: `${process.env.REACT_APP_API}/projects/${projectGroup.project}/media`,
        accept: acceptedFormats,
        headers: {
            Authorization: 'Bearer ' + token
        },
        onChange: onUploadChange,
        multiple: true,
        fileList: uploadFileList
    };

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>
                {includeVideo ? 'Foto o video' : 'Foto'}
            </div>
        </div>
    );

    return (
        <>
            <Text type="secondary" style={{ display: 'block', marginBottom: '8px' }}>
                {'Soporta hasta'} {props.maxPhotos} {includeVideo ? 'imágenes o videos' : 'imágenes'}. 
                {` Máx: 5MB foto${includeVideo ? ' / 25MB video' : ''}.`}
            </Text>
            <Form.Item 
                name='photo'
                valuePropName="fileList"
                getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
            >
                <Upload {...uploadProps} listType='picture-card' >
                    {uploadFileList.length >= props.maxPhotos ? null : uploadButton}
                </Upload>
            </Form.Item>
        </>
    )
}

export default FormItemUploadPhoto;